 
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      isStealDealSetBProduct(formData) {
        if (this.dataset.stealDealSetB === 'true') return true;

        const variantId = formData.get('id') || this.variantIdInput?.value;
        if (!variantId) return false;

        const config =
          typeof window.getStealDealCartConfig === 'function' ? window.getStealDealCartConfig() : null;
        if (!config?.variantIds || typeof window.isStealDealSetBVariant !== 'function') return false;

        return window.isStealDealSetBVariant(variantId, config.variantIds);
      }

      getStealDealPropertyFields() {
        if (this.dataset.stealDealPropertyName) {
          return {
            name: this.dataset.stealDealPropertyName,
            value: this.dataset.stealDealPropertyValue || 'true',
          };
        }

        const config =
          typeof window.getStealDealCartConfig === 'function' ? window.getStealDealCartConfig() : null;
        if (!config?.propertyName) return null;

        return {
          name: config.propertyName,
          value: config.propertyValue || 'true',
        };
      }

      getStealDealSelectedSellingPlanId(submitter) {
        const currentPlan = this.form.querySelector(
          '[name="selling_plan"]:not(:disabled), [name="selling_plan_id"]:not(:disabled)'
        );
        if (currentPlan?.value) return currentPlan.value;

        const submitterPlan =
          submitter?.dataset?.sellingPlanId ||
          submitter?.dataset?.stealDealSellingPlanId ||
          submitter?.closest?.('[data-selling-plan-id], [data-steal-deal-selling-plan-id]')?.dataset?.sellingPlanId ||
          submitter?.closest?.('[data-selling-plan-id], [data-steal-deal-selling-plan-id]')?.dataset
            ?.stealDealSellingPlanId;
        if (submitterPlan) return submitterPlan;

        return this.dataset.stealDealSellingPlanId || null;
      }

      isStealDealSubscriptionSelected(submitter) {
        if (typeof window.getRechargePurchaseType === 'function') {
          const rechargePurchaseType = window.getRechargePurchaseType(this.form);
          if (rechargePurchaseType === 'subscription') return true;
          if (rechargePurchaseType === 'onetime') return false;
        }

        const scope =
          submitter?.closest?.('.card-wrapper, .product-card-wrapper, product-form') ||
          this.closest('.card-wrapper, .product-card-wrapper') ||
          this;
        const selectedControl = scope?.querySelector?.(
          'input[type="radio"]:checked, input[type="checkbox"]:checked, select'
        );
        const selectedValue = String(
          selectedControl?.value || selectedControl?.dataset?.purchaseType || selectedControl?.dataset?.optionType || ''
        ).toLowerCase();
        const selectedName = String(selectedControl?.name || '').toLowerCase();

        if (['onetime', 'one-time', 'one_time', 'once'].includes(selectedValue)) return false;
        if (selectedValue.includes('subscription') || selectedValue.includes('subscribe')) return true;
        if (selectedName.includes('purchase') && selectedValue && !selectedValue.includes('one')) return true;

        const selectedContainer = scope?.querySelector?.(
          '[data-purchase-type="subscription"], [data-option-type="subscription"], .is-subscription-selected, .subscription.selected'
        );
        return Boolean(selectedContainer);
      }

      syncStealDealSellingPlan(formData, submitter) {
        if (!this.isStealDealSetBProduct(formData)) return;
        if (formData.get('selling_plan') || formData.get('selling_plan_id')) return;
        if (!this.isStealDealSubscriptionSelected(submitter)) return;

        const sellingPlanId = this.getStealDealSelectedSellingPlanId(submitter);
        if (sellingPlanId) formData.set('selling_plan', sellingPlanId);
      }

      rememberPendingStealDealSetBVariant(formData) {
        if (
          typeof window.isStealDealSetBDiscountEnabled === 'function' &&
          !window.isStealDealSetBDiscountEnabled()
        ) {
          return;
        }
        if (!this.isStealDealSetBProduct(formData)) return;

        const variantId = formData.get('id') || this.variantIdInput?.value;
        const property = this.getStealDealPropertyFields();
        if (!variantId || !property?.name) return;

        const currentConfig =
          typeof window.getStealDealCartConfig === 'function' ? window.getStealDealCartConfig() : null;
        let variantIds = currentConfig?.variantIds || ',';
        const normalizedVariantId = String(variantId).split(':')[0];
        if (!variantIds.includes(`,${normalizedVariantId},`)) {
          variantIds += `${normalizedVariantId},`;
        }

        window.__stealDealCartConfig = {
          propertyName: property.name,
          propertyValue: property.value,
          variantIds,
          pendingVariantId: normalizedVariantId,
          pendingAt: Date.now(),
        };
      }

      applyStealDealLineItemProperty(formData) {
        const property = this.getStealDealPropertyFields();
        if (!property?.name) return;

        const stealDealPropertyField = `properties[${property.name}]`;

        if (
          typeof window.isStealDealSetBDiscountEnabled === 'function' &&
          !window.isStealDealSetBDiscountEnabled()
        ) {
          formData.delete(stealDealPropertyField);
          return;
        }

        // Set A never gets Steal Deal property.
        if (this.dataset.stealDealSetA === 'true') {
          formData.delete(stealDealPropertyField);
          return;
        }

        if (!this.isStealDealSetBProduct(formData)) {
          formData.delete(stealDealPropertyField);
          return;
        }

        // PDP may stamp only when: Set B subscription + Set A in cart + no Steal Deal yet.
        const applyProperty =
          typeof window.shouldApplyStealDealSetBProperty === 'function'
            ? window.shouldApplyStealDealSetBProperty(this.form, formData)
            : false;

        if (applyProperty) {
          formData.set(stealDealPropertyField, property.value);
          window.__stealDealExplicitPropertyStamp = true;
        } else {
          formData.delete(stealDealPropertyField);
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        window.__stealDealSubmittingForm = this.form;
        window.__stealDealExplicitPropertyStamp = false;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        this.syncStealDealSellingPlan(formData, evt.submitter);
        this.applyStealDealLineItemProperty(formData);

        // Sticky (and other) product forms may omit quantity; main PDP qty uses input#Quantity-{section} with form="" on the primary form.
        if (!formData.has('quantity')) {
          const sectionId = this.dataset.sectionId;
          if (sectionId) {
            const qtyEl = document.getElementById(`Quantity-${sectionId}`);
            if (qtyEl) {
              let qty = parseInt(qtyEl.value, 10);
              if (!Number.isFinite(qty) || qty < 1) {
                const min = parseInt(qtyEl.getAttribute('min'), 10);
                qty = Number.isFinite(min) && min > 0 ? min : 1;
              }
              formData.set('quantity', String(qty));
            }
          }
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (window.__stealDealSubmittingForm === this.form) {
              window.__stealDealSubmittingForm = null;
            }
            window.__stealDealExplicitPropertyStamp = false;

            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
